/* eslint-disable import/extensions */
// Importing necessary libraries and components
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import { sendMailAgain } from "actions/MerchantSignUp";
import { useSnackbar } from "notistack";
import AppLoader from "components/AppLoader/Index";
import { isArray } from "lodash";
import { retryUserService, sendInviteApiCall } from "../../actions/Operations";
import { profileCodePermissionCheck } from "../../Utils/commonUtils";

// Hook to apply custom styles
const useStyles = makeStyles(styles);

// ManagerSetupMenu component definition
function ManagerSetupMenu(props) {
  const classes = useStyles(); // Applying custom styles
  const [anchorEl, setAnchorEl] = React.useState(null); // State to manage menu anchor
  const [managerListData, setManagerListData] = React.useState(); // State to store manager list data
  const [filteredManager, setFilteredManager] = React.useState(null); // State to store filtered manager data
  const [firstmanager, setFirstManager] = React.useState(false); // State to check if the manager is the first manager
  const [firstmanagerType, setFirstManagerType] = React.useState(false); // State to check if the manager is the first manager
  const [loading, setLoading] = React.useState(false); // State to manage loading state
  const { enqueueSnackbar } = useSnackbar(); // Snackbar for notifications
  const open = Boolean(anchorEl); // Boolean to check if the menu is open
  const profileCode = props.userDetails?.leftMenu?.data?.Profile_Code;
  // Function to handle menu open
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

    //  SAFETY CHECK
    if (typeof props.setValues === "function") {
      props.setValues((pre) => ({
        ...pre,
        status: props.details.Current_Status,
      }));
    }
  };
  const canShowEditServices = () => {
    // VCS Admin check
    const isVCSAdmin =
      profileCodePermissionCheck.profileCode.VCS === profileCode;

    // Primary Manager check
    const isPrimaryManager =
      filteredManager?.Type === "main" &&
      filteredManager?.First_Manager === true;

    // // Allow only VCS Admin or Primary Manager
    // return isVCSAdmin || isPrimaryManager;

    const isSecondaryManager =
      filteredManager?.Type === "main" &&
      filteredManager?.First_Manager === false;
    const isSubManager =
      filteredManager?.Type === "sub" &&
      filteredManager?.First_Manager === false;

    // Use 'let' instead of 'const' since you're reassigning
    let isActivate = false;

    if (isVCSAdmin && isPrimaryManager) {
      isActivate = false;
    } else if (isVCSAdmin && (isSecondaryManager || isSubManager) && !firstmanager) {
      isActivate = true;
    } else if (isPrimaryManager && firstmanager === true) {
      isActivate = false;
    } else if ((isSecondaryManager || isSubManager) && firstmanager === true) {
      isActivate = true;
    }

    return isActivate;
  };

  const editServices = () => {
    const item = props.details;

    if (!item) return;

    localStorage.setItem("businessName", item?.Business_Name);
    localStorage.setItem("Manager_uid", item.Manager_uid);
    localStorage.setItem("User_Id", item.Users_Details?._id);
    localStorage.setItem(
      "searchDataMerchant",
      JSON.stringify({
        searchBusinessName: props.merchantListData.searchBusinessName,
        searchDbaName: props.merchantListData.searchDbaName,
        searchManagerId: props.merchantListData.searchManagerId,
        searchStatus: props.merchantListData.searchStatus,
        searchManagerName: props.merchantListData.searchManagerName,
      })
    );
    props.history.push(
      `/${props.userDetails.layout}/EditServices?id=${item?.Bussines_id}&Manager_id=${item?.Manager_ID}&MerchantSetup=${false}`
    );
  };

  // Effect to fetch manager list data
  React.useEffect(() => {
    setManagerListData(
      props.mainData?.merchantInformation?.managerListNames?.data
    );
    setFirstManager(props.mainData?.merchantInformation?.managerListNames?.metadata?.First_Manager);
    setFirstManagerType(props.mainData?.merchantInformation?.managerListNames?.metadata?.Type);
  }, [props]);

  // Effect to filter manager data based on props.id
  React.useEffect(() => {
    if (managerListData && props.id) {
      const filteredData = managerListData.filter(
        (item) => item._id === props.id
      );
      setFilteredManager(filteredData.length > 0 ? filteredData[0] : null);
    }
  }, [managerListData, props.id]);

  // Function to handle menu close
  const handleClose = (type) => {
    if (type === "edit") {
      props.history.push(
        `/${props.userDetails.layout}/MerchantDetails?id=${props.id}`
      );
    }
    setAnchorEl(null);
  };

  // Function to handle resend invite
  const handleResendInvite = () => {
    setLoading(true);
    props.reSendInviteManagerApiCall(
      {
        Business_OBJid: filteredManager?.Business_Details?._id,
        Manager_OBJid: filteredManager?._id,
      },
      (res) => {
        setLoading(false);
        setAnchorEl(null);
        if (res.status === true) {
          enqueueSnackbar(`${res.message}`, { variant: "success" });
        }
      },
      (err) => {
        setLoading(false);
        setAnchorEl(null);
        enqueueSnackbar(`${err.message}`, { variant: "error" });
      }
    );
  };

  const handleRetry = () => {
    setLoading(true);
    props.retryUserService(
      {
        email: filteredManager?.Email,
        managerId: filteredManager?._id,
        businessId: filteredManager?.Business_Details?._id,
      },
      (res) => {
        setLoading(false);
        setAnchorEl(null);
        enqueueSnackbar(`${res.message}`, { variant: "success" });
      },
      (err) => {
        setLoading(false);
        setAnchorEl(null);
        enqueueSnackbar(`${err.message}`, { variant: "error" });
      }
    );
  };

  // Conditional logic to determine menu visibility
  const showResendInvite =
    isArray(props.details.Status_Code) &&
    props.details.Status_Code.some((item) => item.Status === "Invited") &&
    !props.details.Status_Code.some((item) => item.Status === "Active");

  const showWhitelistedIPs =
    isArray(props.details.Status_Code) &&
    props.details.Status_Code.some((item) => item.Status === "Active");
  const showEditService = canShowEditServices();
  const isVCSAdmin = profileCodePermissionCheck.profileCode.VCS === profileCode;

  const isPrimaryManager =
    filteredManager?.Type === "main" &&
    filteredManager?.First_Manager === true;
  const isSecondaryManager =
    filteredManager?.Type === "main" &&
    filteredManager?.First_Manager === false;
  const isSubManager =
    filteredManager?.Type === "sub" &&
    filteredManager?.First_Manager === false;

  // Use 'let' instead of 'const' since you're reassigning
  let isActivate = false;

  if (isVCSAdmin) {
    isActivate = true;
  } else if (isPrimaryManager && firstmanager === true) {
    isActivate = true;
  } else if (isSecondaryManager && (firstmanager === false || firstmanagerType === "main")) {
    isActivate = true;
  } else if (isSubManager && firstmanagerType === "main") {
    isActivate = true;
  }

  const shouldShowMenu = (showResendInvite || showWhitelistedIPs || showEditService);

  return (
    <div>
      <AppLoader loader={loading} />

      {shouldShowMenu && (
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          style={{ padding: "0px" }}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
      )}

      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        {canShowEditServices() && (
          <MenuItem
            className={classes.dialogBoxDropDown}
            onClick={() => editServices()}
          >
            Edit Services
          </MenuItem>
        )}
        {/* {canShowEditServices() && (
          <MenuItem
            className={classes.dialogBoxDropDown}
            onClick={() => handleRetry()}
          >
            Retry
          </MenuItem>
        )} */}
        {showResendInvite && (
          <MenuItem
            className={classes.dialogBoxDropDown}
            onClick={() => handleResendInvite()}
          >
            Resend Invite
          </MenuItem>
        )}
        {/*
        {showResendInvite &&
          props.details.Status_Code.some(
            (item) => item.Status === "Invited" && item.Service_Code === "ACH"
          ) && (
            <MenuItem
              className={classes.dialogBoxDropDown}
              onClick={() => props.handleAddIconClick()}
            >
              Modify Merchant Accounts
            </MenuItem>
          )} */}

        {showWhitelistedIPs && (
          <MenuItem
            className={classes.dialogBoxDropDown}
            onClick={() => props.handleApiModalClick()}
          >
            Whitelisted IPs
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}

// Prop types for the ManagerSetupMenu component
ManagerSetupMenu.propTypes = {
  details: PropTypes.object,
  history: PropTypes.any,
  openForm: PropTypes.func,
  setStatusPid: PropTypes.func,
  userDetails: PropTypes.object,
  provider: PropTypes.bool,
  setValues: PropTypes.func,
  sendMailAgain: PropTypes.func,
  roles: PropTypes.object,
  sendInviteApiCall: PropTypes.func,
  retryUserService: PropTypes.func,
};

// Mapping Redux state to props
const mapStateToProps = (app) => ({
  formData: app.provideRegistration,
  roles: app.roles,
});

// Connecting the component to Redux
export default connect(mapStateToProps, {
  sendMailAgain,
  sendInviteApiCall,
  retryUserService,
})(ManagerSetupMenu);
